module.exports = __webpack_public_path__ + "img/logo2.f3220226.png";